import { Pipeline } from '../../../store/data/types';
import { GraphView, IEdge, IGraphViewProps, INode, SelectionT } from 'react-digraph';
import graphConfig, { NODE_KEY, nodeShapes, NodesType } from './graphConfig';
import React, { Component, forwardRef, LegacyRef, useEffect, useState } from 'react';
import { useGetServicesQuery } from '../../../store/service/serviceSlice';
import { CircularProgress } from '@mui/material';
import ErrorTypography from '../../../shared/ErrorTypography/ErrorTypography';

type Props = {
  pipeline: Pipeline;
  selected: SelectionT | null;
  onSelect: (selection: SelectionT) => void;
  onCreateEdge: (sourceNode: INode, targetNode: INode) => void;
  onSwapEdge: (sourceNode: INode, targetNode: INode, viewEdge: IEdge) => void;
  onDeleteSelected: (selection: SelectionT) => void;
  onUndo: () => void;
};

const PipelineGraph = forwardRef(
  (
    { pipeline, selected, onSelect, onCreateEdge, onSwapEdge, onDeleteSelected, onUndo }: Props,
    ref: LegacyRef<Component<IGraphViewProps, unknown, unknown>>
  ): JSX.Element => {
    const { data, error, isLoading } = useGetServicesQuery(undefined);

    const [nodeTypes, setNodeTypes] = useState({} as NodesType);

    useEffect(() => {
      if (data) {
        const nodeTypesNew: NodesType = {};
        data.services.forEach(service => {
          const type = service.type;
          const width = String(service.name_en.length * 10);
          const id = service.service;
          nodeTypesNew[service.service] = {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            shape: nodeShapes[type],
            shapeId: `#${type}`,
            typeText: service.name_en,
          };
        });
        setNodeTypes(nodeTypesNew);
      }
    }, [data]);

    if (error) {
      return <ErrorTypography />;
    } else if (!isLoading && data && pipeline && Object.keys(nodeTypes).length > 0) {
      return (
        <GraphView
          key={pipeline.pid}
          nodes={pipeline.graph.nodes}
          edges={pipeline.graph.edges}
          nodeKey={NODE_KEY}
          edgeTypes={graphConfig.edgeTypes}
          nodeSubtypes={graphConfig.nodeSubtypes}
          nodeTypes={nodeTypes}
          selected={selected}
          //gridSize={1000}
          gridSpacing={20}
          layoutEngineType={'SnapToGrid'}
          onSelect={onSelect}
          onCreateEdge={onCreateEdge}
          onSwapEdge={onSwapEdge}
          onDeleteSelected={onDeleteSelected}
          onUndo={onUndo}
          //renderNode={renderNode}
          ref={ref}
        />
      );
    } else {
      return <CircularProgress />;
    }
  }
);

export default PipelineGraph;
